import { useAuthenticatedClient } from '@/api/useApi';
import { useWorkspacesApi, useWorkspacesForSidebarApi } from '@/api/workspaces';
import { useParams } from 'react-router-dom';

export const useWorkspacesService = () => {
  const { data, isLoading, error, ...rest } = useWorkspacesApi();
  const { isLoaded, isSignedIn } = useAuthenticatedClient();

  return {
    workspaces: data,
    isLoading,
    error,
    isLoaded,
    isSignedIn,
    ...rest,
  };
};

export const useWorkspacesForSidebarService = () => {
  const { data, isLoading, error, ...rest } = useWorkspacesForSidebarApi();
  const { isLoaded, isSignedIn } = useAuthenticatedClient();

  return {
    workspaces: data,
    isLoading,
    error,
    isLoaded,
    isSignedIn,
    ...rest,
  };
};

export const useCurrentWorkspaceService = () => {
  const { workspaces, ...rest } = useWorkspacesService();
  const { workspaceUname } = useParams<{ workspaceUname: string }>();

  const currentWorkspace = workspaces?.find(w => w.uname === workspaceUname);

  return { currentWorkspace, ...rest };
};
